export default "__VITE_ASSET__73C8EbwY__"